import { Record } from "immutable";
import { DirectoryConfigurationStatus, DirectorySyncMode, type TDirectory } from "types/directoryConfiguration";

const defaults = {
  directory: "" as TDirectory,
  displayName: "",
  id: "",
  isDirectManagerSource: false,
  lastSuccessfulSync: new Date(0),
  nextSyncTime: new Date(0),
  status: "" as DirectoryConfigurationStatus,
  syncMode: DirectorySyncMode.FULL,
};

type TIntegrationStatus = "connected" | "failedSyncing" | "syncing";

const INTEGRATION_STATUS_MAP = {
  [DirectoryConfigurationStatus.CONNECTED]: "connected",
  [DirectoryConfigurationStatus.DIRECTORY_PREVIEW_DONE]: "syncing",
  [DirectoryConfigurationStatus.DIRECTORY_PREVIEW_FAILED]: "failedSyncing",
  [DirectoryConfigurationStatus.DIRECTORY_PREVIEW_WITH_MEMBERS_DONE]: "syncing",
  [DirectoryConfigurationStatus.DIRECTORY_PREVIEW_WITH_MEMBERS_FAILED]: "failedSyncing",
  [DirectoryConfigurationStatus.FAILED_SYNCING]: "failedSyncing",
  [DirectoryConfigurationStatus.INITIALIZING]: "syncing",
  [DirectoryConfigurationStatus.PENDING]: "syncing",
} as const;

export class DirectoryConfigurationModel extends Record<typeof defaults>(defaults) {
  get integrationStatus(): TIntegrationStatus {
    return INTEGRATION_STATUS_MAP[this.status] ?? "syncing";
  }

  static fromServerData(data: unknown) {
    const { directory, displayName, id, isDirectManagerSource, lastSuccessfulSync, nextSyncTime, status, syncMode } =
      data as typeof defaults;
    return new DirectoryConfigurationModel({
      directory,
      displayName,
      id,
      isDirectManagerSource,
      lastSuccessfulSync: lastSuccessfulSync ? new Date(lastSuccessfulSync) : new Date(0),
      nextSyncTime: new Date(nextSyncTime),
      status,
      syncMode,
    });
  }
}
